import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { UserGroup } from '../models/user-group-modal';
import { ApiService } from './api.service';

const routes = {
  userGroup: '/user-groups/permission',
  update: '/users/group-user/update',
  features: '/features',
  featureGroups: '/feature-groups',
  allFeatures: '/common/features',
  allFeaturesGroups: '/common/feature-groups',
  getPemission: '/permissions/group/grant-permission',
  getPerById: (id: any) => `/permissions/group/permission/${id}`,
  getUserById: (id: any) => `/users/group-user/find-by-enterprise/${id}`,
  getUserForwardByContractId: () => `/users/forward-contract`,
  getTree: '/user-groups/tree'
};

@Injectable({
  providedIn: 'root'
})
export class UserGroupService {

  userGroup: UserGroup[];

  constructor(private apiService: ApiService, private httpClient: HttpClient) { }

  getAll(filter: any) {
    return this.apiService.postSilently('/users/group-user/search', filter)
      .pipe(map(res => {
        return res;
      }));
  }

  getAllFeatures() {
    return this.apiService.get(routes.allFeatures)
      .pipe(map(res => {
        return res;
      }));
  }

  getAllFeaturesGroups() {
    return this.apiService.get(routes.allFeaturesGroups)
      .pipe(map(res => {
        return res;
      }));
  }

  addUserGroup(data: any, errCallback?: any) {
    return this.apiService.post('/users/group-user', data)
      .pipe(map(res => {
        if (errCallback && !res.success) errCallback(res);
        return res;
      }));
  }

  updateUserGroup(data: any, callBack: any, noCallBack: any, errCallback: any) {
    return this.apiService.putAndCheckVersion(
      routes.update,
      data,
      callBack,
      noCallBack,
      errCallback
    );
  }

  authoUserGroup(data: any, callBack: any, noCallBack: any) {
    return this.apiService.putAndCheckVersion(
      routes.userGroup,
      data,
      callBack,
      noCallBack
    );
  }

  authoUserGroupEnterprise(data: any, callBack: any, noCallBack: any, errCallback?: any) {
    return this.apiService.putAndCheckVersion(
      routes.userGroup,
      data,
      callBack,
      noCallBack,
      errCallback
    );
  }

  grantPermission(data) {
    return this.apiService.post(routes.getPemission, data)
      .pipe(map(res => {
        return res;
      }));
  }

  getPermissionById(id: number) {
    return this.apiService.get(routes.getPerById(id))
      .pipe(map(res => {
        return res;
      }));
  }

  featureGroups(): Observable<UserGroup[]> {
    return this.apiService.get(routes.featureGroups).pipe(
      tap(rs => console.log(rs)),
      map(rs => rs)
    );
  }

  changeStatusUserGroup(id: number) {
    return this.apiService.post(`/users/group-user/status/${id}`);
  }

  getGroupUserById(id: any) {
    return this.apiService.get(`/user-groups/permission/${id}`)
      .pipe(map(res => {
        return res;
      }));
  }

  getServiceType(id: any) {
    return this.apiService.get(`/common/service-type/${id}`)
      .pipe(map(res => {
        return res;
      }));
  }

  getFeatureGrId() {
    return this.apiService.get(`/common/feature-group/manager-and-sign-feature-group-id`)
      .pipe(map(rs => {
        return rs;
      }));
  }

  getUserForwardContractByContractId(filter: any) {
    return this.apiService.post(routes.getUserForwardByContractId(), filter)
      .pipe(map(res => {
        return res;
      }));
  }

  getAllUsers(filter: any) {
    return this.apiService.post('/users/user-by-enterprise/search', filter)
      .pipe(map(res => {
        return res;
      }));
  }

  addUserGroupAdmin(data: any, errCallback?: any) {
    return this.apiService.post('/users/group-admin', data)
      .pipe(map(res => {
        if (errCallback && !res.success) errCallback(res);
        return res;
      }));
  }

  getAllUserAdmin(filter: any) {
    return this.apiService.post('/users/group-user/search-admin', filter)
      .pipe(map(res => {
        return res;
      }));
  }

  deleteAdmin(serviceTypeId: number) {
    return this.apiService.post(`/users/group-user/delete-admin/${serviceTypeId}`).pipe(map(res => {
      return res;
    }));
  }

  changeStatusAdmin(id: number) {
    return this.apiService.post(`/users/group-user/status-admin/${id}`);
  }

  getGroupAdminById(id: any) {
    return this.apiService.get(`/user-groups/permission-admin/${id}`)
      .pipe(map(res => {
        return res;
      }));
  }

  updateUserGroupAdmin(data: any, callBack: any, noCallBack: any, errCallback: any) {
    return this.apiService.putAndCheckVersion(
      '/users/group-user/update-admin',
      data,
      callBack,
      noCallBack,
      errCallback
    );
  }

  getTree() {
    return this.apiService.get(`/user-groups/tree`)
      .pipe(map(res => {
        return res;
      }));
  }

  searchTree(keyword: string) {
    const body = {
      keyword: keyword
    }
    return this.apiService.post(`/user-groups/search-tree`, body)
    .pipe(map(res => {
      return res;
    }));
  }

  getTreeNodes(params: { parentId: string, parentType: string }) {
    return this.apiService.get(`/user-groups/tree/get-nodes?parentId=${params.parentId}&parentType=${params.parentType}`)
    .pipe(map(res => {
      return res;
    }));
  }
}
